import { render, staticRenderFns } from "./PricingForm.vue?vue&type=template&id=6daf1d54&scoped=true&"
import script from "./PricingForm.vue?vue&type=script&lang=ts&"
export * from "./PricingForm.vue?vue&type=script&lang=ts&"
import style0 from "./PricingForm.vue?vue&type=style&index=0&id=6daf1d54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daf1d54",
  null
  
)

export default component.exports